import Vue from 'vue'

const Base = new Vue()
export {
  // eslint-disable-next-line import/prefer-default-export
  Base,
}
